<template>
  <div>
    <div v-show="tab == 'ordermanager'">
      <OrderManager></OrderManager>
    </div>
    <div v-show="tab == 'profile'">
      <Profile></Profile>
    </div>
    <v-bottom-navigation
      fixed
      x-large
      v-model="tab"
      color="primary"
      grow
      style="bottom: -2px; max-width: 500px; left: 50%; transform: translateX(-50%)"
    >
      <v-btn value="ordermanager" height="100%">
        <v-icon large>mdi-menu</v-icon>
      </v-btn>

      <v-btn value="profile" height="100%">
        <v-icon large>mdi-account-outline</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script>
import OrderManager from './OrderManager.vue'
import Profile from './Profile.vue'
export default {
  data() {
    return {
      tab: 'ordermanager'
    }
  },
  components: {
    Profile,
    OrderManager
  }
}
</script>

<style lang="scss" scoped></style>
